import { combineReducers } from 'redux'
import parse from '../adapters/parsers/availableCategoriesParser'
import { handleResponse } from './api/apiUtils'
import * as urls from './api/urls'
import { SET_CURRENT_PROPERTY } from './properties'

/* Constants */
export const AVAILABLE_CATEGORIES_REQUEST = 'AVAILABLE_CATEGORIES_REQUEST'
export const AVAILABLE_CATEGORIES_SUCCESS = 'AVAILABLE_CATEGORIES_SUCCESS'
export const AVAILABLE_CATEGORIES_FAILURE = 'AVAILABLE_CATEGORIES_FAILURE'
export const AVAILABLE_CATEGORIES_CLEAR = 'AVAILABLE_CATEGORIES_CLEAR'

/* Reducers */

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {}
        case AVAILABLE_CATEGORIES_SUCCESS:
            return action.payload.entities
        case AVAILABLE_CATEGORIES_CLEAR:
            return []
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return []
        case AVAILABLE_CATEGORIES_SUCCESS:
            return action.payload.result
        case AVAILABLE_CATEGORIES_CLEAR:
            return []
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return null
        case AVAILABLE_CATEGORIES_FAILURE:
            return action.payload
        case AVAILABLE_CATEGORIES_SUCCESS:
            return null
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return false
        case AVAILABLE_CATEGORIES_REQUEST:
            return true
        case AVAILABLE_CATEGORIES_SUCCESS:
        case AVAILABLE_CATEGORIES_FAILURE:
        case AVAILABLE_CATEGORIES_CLEAR:
            return false
        default:
            return state
    }
}

export const availableCategoriesReducer = combineReducers({ entities, result, isFetching, error })

/* Thunks */

/**
 * Fetches array of available categories for selected time
 *
 * @param {Object} params - List of path params
 * @param {number} params.startTime - Selected startTime in UTC+0 UNIX timestamp
 * @param {number} params.endTime - Selected endTime in UTC+0 UNIX timestamp
 */
export const getAvailableCategories = params => (dispatch, getState) => {
    dispatch(availableCategoriesRequest())

    const { secretKey, properties } = getState()
    const { currentProperty } = properties

    const opts = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    }

    fetch(
        urls.availableCategoriesUrl(secretKey, {
            propertyId: currentProperty,
            ...params
        }),
        opts
    )
        .then(handleResponse)
        .then(json => parse(json))
        .then(json => dispatch(availableCategoriesSuccess(json)))
        .catch(err => console.error(err))
}

/**
 * Clears available categories from store
 */
export const clearAvailableCategories = () => dispatch => {
    dispatch(availableCategoriesClear())
}

/* Action Creators */

/** @action **/
export const availableCategoriesRequest = () => ({
    type: AVAILABLE_CATEGORIES_REQUEST
})

/** @action **/
export const availableCategoriesSuccess = availableCategories => ({
    type: AVAILABLE_CATEGORIES_SUCCESS,
    payload: { entities: availableCategories.entities, result: availableCategories.result }
})

/** @action **/
export const availableCategoriesClear = () => ({
    type: AVAILABLE_CATEGORIES_CLEAR
})

/** @action **/
export const availableCategoriesFailure = error => ({
    type: AVAILABLE_CATEGORIES_FAILURE,
    payload: {
        status: error.response.status,
        statusText: error.response.statusText
    }
})



// WEBPACK FOOTER //
// ./modules/availableCategories.js